import { Image } from 'expo-image';
import { View } from 'react-native';

export const ConfirmHeaderOverlay = ({ backgroundColor }: { backgroundColor?: string }) => (
  <View
    style={{
      backgroundColor,
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
    }}
  >
    <View style={{ position: 'relative', height: 35 }}>
      <Image
        source={require('./spongebob-movie-only-in-theaters.webp')}
        style={{
          flex: 1,
          height: 90,
          width: 175,
          resizeMode: 'contain',
          position: 'absolute',
          top: 0,
          left: 5,
          zIndex: 1,
        }}
      />
    </View>
  </View>
);
